<template>
  <div v-if="collection" class="form-container">
    <div style="margin-left: 150px">
      <el-tabs class="tfam-custom-tabs" v-model="currentLang">
        <el-tab-pane
          v-for="(lang) in langList"
          :key="lang['language_key']"
          :label="lang['title']"
          :name="lang['language_key']"></el-tab-pane>
      </el-tabs>
    </div>
    <el-form ref="form" :model="collection" label-width="150px">
      <el-form-item label="作品名稱">
        <el-input v-model="collection[currentLang].title"></el-input>
      </el-form-item>
      <el-form-item label="作者">
        <el-tooltip class="item" effect="dark" content='可透過直接輸入格式 "中文(空格)英文" EX.陳順築 Chen, Shun-Zhu' placement="top">
          <curator-select
            :select-artists="collection.artist"
            place-holder-text="選擇作者"
            propName="artist"
            :update-artist="updateArtistList"
            @update="updateArtists"
          ></curator-select>
        </el-tooltip>
      </el-form-item>
      <el-form-item label="作品創作年代">
        <el-row class="text-flex-content">
          <el-date-picker
            v-model="collection.creation_start"
            type="year"
            placeholder="YYYY"
            format="yyyy"></el-date-picker>
          <span class="divider"> - </span>
          <el-date-picker
            v-model="collection.creation_end"
            type="year"
            placeholder="YYYY"
            format="yyyy"></el-date-picker>
        </el-row>
      </el-form-item>
      <el-form-item label="尺寸">
        <el-row class="text-flex-content">
          <el-input v-model="collection.size_length" placeholder="長"></el-input>
          <span class="divider"> / </span>
          <el-input v-model="collection.size_width" placeholder="寬"></el-input>
          <span class="divider"> / </span>
          <el-input v-model="collection.size_height" placeholder="高"></el-input>
          <span class="divider"> / </span>
          <el-input v-model="collection.size_quantity" placeholder="數量"></el-input>
        </el-row>
      </el-form-item>
      <el-form-item label="媒材">
        <el-input v-model="collection[currentLang].medium"></el-input>
      </el-form-item>
      <el-form-item label="使用展間">
        <room-selector
          :selected-rooms="collection.rooms"
          :multiple="false"
          @update="updateRooms"></room-selector>
      </el-form-item>
      <el-form-item label="封面圖片">
        <div class="image-content collection-image demo-image__error" :style="{ height: imageSize.height + 'px'}">
          <div class="block">
            <el-image id="collectionImage" :src="getCollectionImage()" fit="contain" @load="loadImageSuccess">
              <div slot="error" class="image-slot">
                <i class="el-icon-picture-outline"></i>
              </div>
            </el-image>
          </div>
        </div>
        <input id="fileInput" type="file" @change="onImagesChange" accept="image/jpeg, image/png" hidden>
        <div style="margin-top: 20px">
          <el-button @click="handleUploadImage">{{ collection.images.length > 0 ? collection.images[0]['original_name'] : '選擇檔案' }}</el-button>
          <el-button v-if="uploadImages.length > 0" plain @click="removeUploadImage">移除所選檔案</el-button>
        </div>
        <!--
        <el-upload
          action=""
          :file-list="uploadImages"
          :auto-upload="false"
          :limit="5"
          list-type="picture-card"
          class="tfam-upload"
          :on-change="handleFileChange"
          accept="image/*"
          multiple>
          <i class="el-icon-plus"></i>
          <div slot="file" slot-scope="{file}" style="width: 100%; height: 100%;">
            <img
              class="el-upload-list__item-thumbnail"
              style="object-fit: cover"
              :src="file.url" alt="">
            <div class="picture-card-style-control">
              <span class="file-name">{{ file.name }}</span>
              <span
                class="remove-button"
                @click="handleRemoveFile(file)">
                <i class="el-icon-delete"></i>
              </span>
            </div>
          </div>
        </el-upload>
        <div :style="{ marginTop: uploadImages.length > 0 ? '0' : '20px'}">
          <el-button plain @click="removeUploadImage">移除所選檔案</el-button>
        </div>
        -->
      </el-form-item>
      <el-form-item label="QRcode URL">
        <div class="qrcode-content">
          <!--
          <span>{{ qrcodeComputed }}</span>
          -->
          <span>{{ collection.firebase_dynamic_link }}</span>
        </div>
      </el-form-item>
      <el-form-item label="導覽類型">
        <el-radio v-model="collection[currentLang].collection_type" label="audio">語音</el-radio>
        <el-radio v-model="collection[currentLang].collection_type" label="video">影片</el-radio>
      </el-form-item>
      <div v-if="collection[currentLang].collection_type === 'video'">
        <el-form-item label="導覽影片連結">
          <el-input
            v-model="collection[currentLang].video_url"
            maxlength="512"
            show-word-limit
          ></el-input>
        </el-form-item>
      </div>
      <div v-else>
        <el-form-item label="語音編號">
          <el-input v-model="collection.collection_no"></el-input>
        </el-form-item>
        <el-form-item label="語音導覽">
          <input id="audioFileInput" type="file" @change="onAudioFileChange" accept=".mp3,audio/*" hidden multiple>
          <el-row class="text-flex-content">
            <el-button plain @click="handleUploadAudio">
              {{ collection[currentLang].audios.length > 0 ? collection[currentLang].audios[0]['original_name'] : '選擇檔案' }}
            </el-button>
            <el-button v-if="uploadAudio[currentLang]" plain @click="clearAudioInput">移除所選檔案</el-button>
            <el-button v-else-if="collection[currentLang].audios.length > 0" plain @click="removeAudio">移除已上傳檔案</el-button>
          </el-row>
        </el-form-item>
      </div>
      <el-form-item label="簡介">
        <el-input
          type="textarea"
          :autosize="{ minRows: 5, maxRows: 8}"
          v-model="collection[currentLang].introduction"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button v-if="collection.firebase_dynamic_link === null" class="tfam-button" plain @click="handleCreateFirebaseDynamicLink">產生QRcode網址</el-button>
        <el-button class="tfam-button" plain v-loading.fullscreen.lock="fullLoading" @click="handelSubmitUpdate">更新並儲存</el-button>
        <el-button class="tfam-button" plain @click="goBack">返回至上一層</el-button>
        <el-button class="tfam-button" plain @click="handleDeleteRow">捨棄這筆資料</el-button>
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
  import {
    fetchCollection,
    createCollection,
    updateCollection,
    createCollectionLang,
    updateCollectionLang,
    deleteCollection,
    deleteCollectionLang,
    createCollectionFirebaseDynamicLink
  } from "../../api/collection";
import { fetchArtistList, createArtist, createArtistLang } from "../../api/artist";
import { storageUploadFiles, getGCPFileUrl } from "../../api/attachment";
import { fetchFloorList } from "../../api/floor";
import { createImage, deleteImage } from "../../api/image";
import { createAudio, deleteAudio } from "../../api/audio";
import CuratorSelect from "../Componments/CuratorSelect";
import lodash from 'lodash'
  import RoomSelector from "../Componments/RoomSelector";

export default {
  name: "CollectionEdit",
  components: {RoomSelector, CuratorSelect},
  data() {
    return {
      currentLang: 'ZH_TW',
      langList: this.$store.getters.langList,
      collectionId: undefined,
      exhibitionId: undefined,
      collection: undefined,
      originCollection: undefined,
      fullLoading: true,
      artistList: [],
      uploadImages: [],
      uploadAudio: {},
      updateArtistList: new Date().getTime(),
      imageSize: {
        width: 300,
        height: 400
      }
    }
  },
  computed: {
    qrcodeComputed: function () {
      return 'tfamorg://' + this.collectionId
    }
  },
  methods: {
    loadImageSuccess(event) {
      const element = document.getElementById("collectionImage");
      const width = element.naturalWidth;
      const height = element.naturalHeight;
      this.imageSize.height = (300 / width) * height
    },
    getCollectionImage() {
      if (this.uploadImages.length > 0) {
        return this.collection.images[0]['file'];
      } else {
        if (this.collection.images.length > 0) {
          return getGCPFileUrl(this.collection.images[0]['name']);
        } else {
          return ''
        }
      }
    },
    updateRooms(val) {
      this.collection['rooms'] = val;
      // console.log(this.collection['rooms']);
    },
    updateArtists(val) {
      this.collection[val['propName']] = val['data'];
    },
    // handleRemoveFile(file) {
    //   let index = -1;
    //   for (const i in this.uploadImages) {
    //     if (this.uploadImages[i]['uid'] === file['uid']) {
    //       index = parseInt(i);
    //       break
    //     }
    //   }
    //   if (index >= 0) {
    //     this.uploadImages.splice(index, 1);
    //   }
    // },
    // handleFileChange(file, fileList) {
    //   this.uploadImages = fileList;
    // },
    // removeUploadImage() {
    //   // this.setupUploadImageList();
    // },
    // setupUploadImageList() {
    //   this.uploadImages = [];
    //   for (const i in this.collection.images) {
    //     setTimeout(() => {
    //       const uid = new Date().getTime();
    //       this.uploadImages.push({
    //         name: this.collection.images[i]['original_name'],
    //         url: getGCPFileUrl(this.collection.images[i]['name']),
    //         uid: uid,
    //         status: 'success',
    //         data: this.collection.images[i]
    //       })
    //     }, 100);
    //   }
    // },
    onImagesChange(event){
      const files = event.target.files;
      if (files) {
        const files_count = files.length;
        for (let i = 0; i < files_count; i++){
          const reader = new FileReader();
          reader.onload = (e) => {
            this.collection['images'] = [];
            this.collection['images'] = [{
              file: e.target.result,
              name: files[i]['name'],
              original_name: files[i]['name']
            }];
            this.uploadImages = files;
          };
          reader.readAsDataURL(files[i]);
        }
      }
    },
    handleUploadImage() {
      document.getElementById("fileInput").click()
    },
    removeUploadImage() {
      if (this.originCollection ) {
        this.collection.images = lodash.cloneDeep(this.originCollection.images);
      }
      this.uploadImages = [];
      if (document.getElementById("fileInput")) {
        document.getElementById("fileInput").value = '';
      }
    },
    handleUploadAudio() {
      document.getElementById("audioFileInput").click()
    },
    clearAudioInput() {
      delete this.uploadAudio[this.currentLang];
      if (this.originCollection) {
        this.collection[this.currentLang]['audios'] = lodash.cloneDeep(this.originCollection[this.currentLang]['audios']);
      }
      if (document.getElementById("audioFileInput")) {
        document.getElementById("audioFileInput").value = '';
      }
    },
    onAudioFileChange(event) {
      const files = event.target.files;
      this.uploadAudio[this.currentLang] = files[0];
      this.collection[this.currentLang]['audios'] = [{
        name: files[0]['name'],
        original_name: files[0]['name']
      }];
      if (document.getElementById("audioFileInput")) {
        document.getElementById("audioFileInput").value = '';
      }
    },
    removeAudio() {
      this.collection[this.currentLang].audios = [];
    },
    getCollectionData() {
      this.fullLoading = false;
      const filter = {
        include: ['collectionLangs']
      };
      this.removeUploadImage();
      this.clearAudioInput();
      fetchCollection(this.collectionId, filter).then(response => {
        console.log('fetchCollection');
        const collection = response.data;
        for (const i in this.langList) {
          const lang = this.langList[i]['language_key'];
          const filter = collection['collectionLangs'].filter(x => x['language_key'] === lang);
          collection[lang] = {};
          if (filter.length > 0) {
            collection[lang]['collection_lang_id'] = filter[0]['collection_lang_id'];
            collection[lang]['language_key'] = lang;
            collection[lang]['title'] = filter[0]['title'];
            collection[lang]['introduction'] = filter[0]['introduction'];
            collection[lang]['audios'] = filter[0]['audios'];
            collection[lang]['medium'] = filter[0]['medium'];
            collection[lang]['collection_type'] = filter[0]['collection_type'];
            collection[lang]['video_url'] = filter[0]['video_url'];
          } else {
            collection[lang]['collection_lang_id'] = 'new';
            collection[lang]['language_key'] = lang;
            collection[lang]['title'] = '';
            collection[lang]['introduction'] = '';
            collection[lang]['audios'] = [];
            collection[lang]['medium'] = '';
            collection[lang]['collection_type'] = 'audio';
            collection[lang]['video_url'] = '';
          }
        }
        this.collection = collection;
        this.originCollection = lodash.cloneDeep(collection);
        this.uploadAudio = {};
        // this.setupUploadImageList();
      }).catch(err => {
      })
    },
    getCollectionDataFromOlder() {
      this.fullLoading = false;
    },
    getRoomList() {
      const filter = {
        include: ['rooms']
      };
      fetchFloorList(filter).then(response => {
        this.roomList = response.data;
        this.roomOptions = [];
        for (const i in this.roomList) {
          const floorData = this.roomList[i];
          const roomOption = {
            value: floorData['floor_id'],
            label: floorData['name'],
            children: []
          };
          for (const rIndex in floorData['rooms']) {
            roomOption.children.push({
              value: floorData['rooms'][rIndex]['room_id'],
              label: floorData['rooms'][rIndex]['name'],
            })
          }
          this.roomOptions.push(roomOption);
        }
      }).catch(err => {
      })
    },
    getArtistList() {
      const filter = {
        include: [{
          relation: 'artistLangs',
          scope: {
            where: {
              language_key: 'ZH_TW'
            }
          }
        }]
      };
      fetchArtistList(filter).then(response => {
        this.artistList = response.data;
      }).catch(err => {

      })
    },
    handelSubmitUpdate() {
      console.log(this.uploadAudio);
      this.fullLoading = true;
      this.submitUpdate().then(response => {
        this.fullLoading = false;
        this.$message({
          type: 'success',
          message: '儲存成功!'
        });
        if (this.$route.params.collectionId === 'new') {
          this.$router.push({
            path: '/exhibitions/v2/' + this.exhibitionId + '/collections/' + response['collectionId']
          });
        }
        this.collectionId = response['collectionId'];
        this.getCollectionData();
        if (response['updateNewArtist']) {
          this.updateArtistList = new Date().getTime();
        }
      }).catch(err => {
        console.log(err);
        let message = err;
        if (err.response) {
          message = err.response.data.error.message + '!'
        }
        this.$alert(message, '儲存失敗', {
          confirmButtonText: '確定',
          callback: action => {
          }
        });
        this.fullLoading = false;
      })
    },
    submitUpdate: async function() {
      try {
        let updateNewArtist = false;
        let collectionId = this.collection.collection_id;
        const collectionData = lodash.cloneDeep(this.collection);
        const newArtistList = [];
        delete collectionData['images'];
        for (const i in collectionData['artist']) {
          const artist = collectionData['artist'][i];
          if (artist.indexOf('建立') >= 0) {
            const date = new Date().getFullYear();
            const newArtist = await createArtist({ born: date});
            const name = artist.replace('建立 ', '');
            const nameSplit = name.split(' ');
            const artistLangZH = {
              artist_id: newArtist.data['artist_id'],
              language_key: 'ZH_TW',
              name: nameSplit[0]
            };
            const enName = nameSplit.slice(1);
            await createArtistLang(artistLangZH);
            const artistLangEN = {
              artist_id: newArtist.data['artist_id'],
              language_key: 'EN',
              name: enName.join(' ')
            };
            await createArtistLang(artistLangEN);
            newArtistList.push(newArtist.data['artist_id']);
            updateNewArtist = true;
          } else {
            newArtistList.push(artist);
          }
        }
        collectionData['artist'] = newArtistList;
        console.log('START submitUpdate');
        collectionData['exhibition_id'] = this.exhibitionId;
        if (collectionId === 'new') {
          const newCollection = await createCollection(collectionData);
          collectionId = newCollection.data['collection_id'];
        } else {
          await updateCollection(collectionId, collectionData)
        }
        console.log('START IMAGES');
        console.log(this.uploadImages);
        if (this.uploadImages.length > 0) {
          const uploadResult = await storageUploadFiles(this.uploadImages);
          const files = uploadResult.data.result.files.file;
          const fileName = files[0]['name'];
          const originalFilename = files[0]['originalFilename'];
          await createImage({
            name: fileName,
            original_name: originalFilename,
            object_id: collectionId
          });
          console.log(this.originCollection);
          if (this.originCollection.images.length > 0) {
            for (const i in this.originCollection.images) {
              const imageId = this.originCollection.images[i]['image_id'];
              await deleteImage(imageId);
            }
          }
        }
        console.log('START LANG');
        console.log(collectionData);
        console.log(this.langList);
        for (const i in this.langList) {
          const langKey = this.langList[i]['language_key'];
          console.log('LANG\t' + langKey);
          const collectionLang = collectionData[langKey];
          let collectionLangId = collectionLang['collection_lang_id'];
          if (collectionLangId === 'new') {
            collectionLang['collection_id'] = collectionId;
            const newCollectionLang = await createCollectionLang(collectionLang);
            collectionLangId = newCollectionLang.data['collection_lang_id']
          } else {
            await updateCollectionLang(collectionLangId, collectionLang);
          }
          if (this.uploadAudio[langKey]) {
            console.log('NEED UPLOAD FILE');
            const uploadAudioResult = await storageUploadFiles([this.uploadAudio[langKey]]);
            const files = uploadAudioResult.data.result.files.file;
            if (this.originCollection[langKey]['audios'] && this.originCollection[langKey]['audios'].length > 0) {
              await deleteAudio(this.originCollection[langKey]['audios'][0]['audio_id'])
            }
            await createAudio({
              name: files[0]['name'],
              original_name: files[0]['originalFilename'],
              object_id: collectionLangId
            });
          } else if (this.originCollection[langKey]['audios'].length !== this.collection[langKey]['audios'].length){
            console.log('NOT NEED UPLOAD FILE，BUT NEED REMOVE FILE');
            for (const audioIndex in this.originCollection[langKey]['audios']) {
              await deleteAudio(this.originCollection[langKey]['audios'][audioIndex]['audio_id'])
            }
          } else {
            console.log('NOT NEED UPLOAD FILE');
          }
        }
        return Promise.resolve({
          collectionId,
          updateNewArtist
        });
      } catch (e) {
        return Promise.reject(e);
      }
    },
    goBack() {
      this.$router.push({
        path: '/exhibitions/v2/' + this.exhibitionId + '/collections/'
      });
    },
    handleDeleteRow() {
      if (confirm('確定要捨棄這筆資料嗎？\n(捨棄的資料將無法復原。)')) {
        if (this.collectionId === 'new') {
          this.goBack();
        } else {
          this.fullLoading = true;
          this.submitDeleteRowData().then(response => {
            this.fullLoading = false;
            this.goBack();
          }).catch(err => {
            this.fullLoading = false;
          })
        }
      }
    },
    submitDeleteRowData: async function() {
      try {
        const promiseArray = [];
        promiseArray.push(deleteCollection(this.collectionId));
        this.originCollection['images'].forEach(image => {
          promiseArray.push(deleteImage(image['image_id']))
        });
        this.langList.forEach(lang => {
          const key = lang['language_key'];
          if (this.originCollection[key]['collection_lang_id'] !== 'new') {
            promiseArray.push(deleteCollectionLang(this.originCollection[key]['collection_lang_id']));
          }
          this.originCollection[key]['audios'].forEach(audio => {
            promiseArray.push(deleteAudio(audio['audio_id']))
          });
        });
        await Promise.all(promiseArray);
        return Promise.resolve(true);
      } catch (e) {
        return Promise.reject(e);
      }
    },
    handleCreateFirebaseDynamicLink() {
      this.fullLoading = true;
      createCollectionFirebaseDynamicLink(this.collectionId).then(res => {
        const { data } = res
        this.fullLoading = false;
        if (this.$route.name.includes('v1')) {
          this.getCollectionDataFromOlder()
        } else {
          this.getCollectionData()
        }
        this.$message({
          type: 'success',
          message: '新增成功!'
        });
      }).catch(e => {
        console.log(e)
        this.fullLoading = false;
      })
    }
  },
  mounted() {
    this.getRoomList();
    this.getArtistList();
    this.exhibitionId = this.$route.params.exhibitionId;
    this.collectionId = this.$route.params.collectionId;
    if (this.$route.params.collectionId !== 'new') {
      this.$route.meta.name = '編輯展品';
      if (this.$route.name.includes('v1')) {
        this.getCollectionDataFromOlder()
      } else {
        this.getCollectionData()
      }
    } else {
      this.$route.meta.name = '新增展品';
      this.fullLoading = false;
      const collection = {
        collection_id: 'new',
        collection_no: '',
        images: [],
        artist: [],
        creation_start: undefined,
        creation_end: undefined,
        size_length: undefined,
        size_width: undefined,
        size_height: undefined,
        size_quantity: undefined,
      };
      for (const i in this.langList) {
        const lang = this.langList[i]['language_key'];
        collection[lang] = {};
        collection[lang].language_key = lang;
        collection[lang].collection_lang_id = 'new';
        collection[lang].title = '';
        collection[lang].introduction = '';
        collection[lang].audios = [];
        collection[lang].medium = '';
      }
      this.collection = collection;
      this.originCollection = lodash.cloneDeep(collection);
      // this.setupUploadImageList();
    }
  }
}
</script>

<style lang="scss">
  .text-flex-content {
    display: flex;
    .divider {
      padding: 0 10px;
    }
  }
  .audio-name {
    width: auto;
    /*height: 70px;*/
    padding: 0 20px;
    background-color: white;
    margin-right: 10px;
    /*margin: 10px 0;*/
    span {
      font-size: 14px;
      line-height: 40px;
      color: #222;
    }
  }
  .room-options {
    width: 100%;
  }
  .el-select {
    width: 100%;
  }
  .el-upload-list--picture-card .el-upload-list__item-thumbnail {
    object-fit: contain;
  }
  .el-select-dropdown {
    width: 500px !important;
  }
  .qrcode-content {
    min-width: 300px;
    min-height: 42px;
    /*height: 70px;*/
    padding: 0 20px;
    background-color: white;
    /*margin: 10px 0;*/
    border: 1px solid #DCDFE6;
    border-radius: 4px;
    span {
      font-size: 14px;
      line-height: 40px;
      color: #222;
    }
  }
</style>
